import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Col, Empty, Row } from 'antd'

import B2becProductCard from '@/components/B2becProductCard'
import CustomButton from '@/components/CustomButton'
import { NotificationManager } from '@/components/Notification'
import B2becCardSkeleton from '@/components/Skeletons/B2becCardSkeleton'
import { machineService } from '@/services'
import useAsync from '@/hooks/useAsync'
import { ASYNC_STATUS } from '@/libs/constants'
import { isValidArray } from '@/libs/utils/array'
import { linkGenerator } from '@/libs/utils/language'

const getMyMachines = () =>
  machineService.getMachinesList({
    pageNumber: 1,
    pageSize: 3,
    sortOrder: 'ByOrderDateDesc',
  })

const MyMachines = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [myMachineList, setMyMachineList] = useState([])
  const [totalCount, setTotalCount] = useState(0)

  const handleGetMachineListSuccess = useCallback((response) => {
    setMyMachineList(response?.data?.items)
    setTotalCount(response?.data?.totalCount)
  }, [])

  const handleGetMachineListError = useCallback((error) => {
    NotificationManager.error({
      description: error?.message,
    })
  }, [])

  const { status: getMyMachinesStatus } = useAsync(
    getMyMachines,
    true,
    handleGetMachineListSuccess,
    handleGetMachineListError,
  )

  const isLoading = getMyMachinesStatus === ASYNC_STATUS.PENDING

  return (
    <div className="my-machines__section">
      <h2 className="text-xl uppercase font-bold mb-5">
        {t('myMachines.title')}
      </h2>
      {isLoading
        ? (
          <B2becCardSkeleton
            columns={{ xs: 24, sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }}
            gutter={20}
            hasPrice={false}
            imageHeight={528}
            number={3}
          />
        )
        : isValidArray(myMachineList)
        ? (
          <>
            <Row className="product-card__wrapper pb-5" gutter={[16, 16]}>
              {myMachineList.map((item) => (
                <Col
                  key={`${item?.materialNumber}-${item?.orderDate}-${item?.salesOrderNumber}`}
                  lg={8}
                  md={12}
                  sm={24}
                  xl={8}
                  xs={24}
                >
                  <B2becProductCard
                    categoryName={item.categoryName}
                    imgUrl={item?.imgUrl}
                    materialNumber={item?.materialNumber}
                    name={item?.name}
                    orderDate={item?.orderDate}
                  />
                </Col>
              ))}
            </Row>
            <div className="my-machines__section__see-all">
              <CustomButton
                type="ghost"
                onClick={() => navigate(linkGenerator('/my-machines'))}
              >
                {t('myWorkspace.seeAllMachines', {
                  total: totalCount,
                })}
              </CustomButton>
            </div>
          </>
        )
        : <Empty description={t('noData')} />}
    </div>
  )
}

export default MyMachines
